import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../../utils/cn';

function buildPages(page, total) {
  const pages = [];
  const window = 1;
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= page - window && i <= page + window)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '…') {
      pages.push('…');
    }
  }
  return pages;
}

export function Pagination({ page = 1, total = 1, onChange, showStatus = true, totalItems, pageSize, className }) {
  const pages = buildPages(page, total);
  const onPage = (p) => p !== '…' && p !== page && onChange?.(p);

  return (
    <nav className={cn('flex items-center justify-between gap-3', className)} aria-label="Pagination">
      {showStatus && totalItems && pageSize && (
        <div className="text-xs text-mute font-mono">
          {Math.min((page - 1) * pageSize + 1, totalItems)}–{Math.min(page * pageSize, totalItems)} sur {totalItems}
        </div>
      )}
      <div className="flex items-center gap-1">
        <button
          type="button"
          onClick={() => page > 1 && onChange?.(page - 1)}
          disabled={page === 1}
          aria-label="Page précédente"
          className="h-8 w-8 inline-flex items-center justify-center rounded-md border border-border bg-surface hover:bg-bg-2 disabled:opacity-50 disabled:pointer-events-none transition-colors"
        >
          <ChevronLeft className="w-3.5 h-3.5" strokeWidth={2} />
        </button>
        {pages.map((p, i) => (
          <button
            key={i}
            type="button"
            onClick={() => onPage(p)}
            aria-current={p === page ? 'page' : undefined}
            disabled={p === '…'}
            className={cn(
              'h-8 min-w-8 px-2 text-sm font-medium rounded-md transition-colors',
              p === page
                ? 'bg-ink text-cream'
                : 'border border-border bg-surface text-text hover:bg-bg-2',
              p === '…' && 'pointer-events-none bg-transparent border-transparent text-mute',
            )}
          >
            {p}
          </button>
        ))}
        <button
          type="button"
          onClick={() => page < total && onChange?.(page + 1)}
          disabled={page === total}
          aria-label="Page suivante"
          className="h-8 w-8 inline-flex items-center justify-center rounded-md border border-border bg-surface hover:bg-bg-2 disabled:opacity-50 disabled:pointer-events-none transition-colors"
        >
          <ChevronRight className="w-3.5 h-3.5" strokeWidth={2} />
        </button>
      </div>
    </nav>
  );
}

export default Pagination;
